import React, { useState } from 'react';
import { Stack, TextField, Typography, Button, Autocomplete } from "@mui/material";
import { useNavigate } from 'react-router-dom';

import { useForm } from '../../../hooks/useForm';
import './style.css';
import { Message } from '../../../components/Message';
import { messagesCreateProducts, messagesEditProducts } from '../../../helpers/productMessage';

export const AddProducts = ({ data }) => {

    const [formValues, handleInputChange, reset] = useForm(data ? data[0] : {
        product: '', measure: '', price: '', type: ''
    });

    const { product, measure, price, type } = formValues;
    const [body, setBody] = useState(false)
    const navigate = useNavigate();

    const handleCancel = () => {
        navigate('/product')
    }

    const handleSubmit = (e) => {
        console.log(measure);
        console.log(data);

        e.preventDefault();
        const obj = {
            'product': e.target.product.value,
            'measure': measure,
            'price': e.target.price.value,
            'type': type
        }
        if (data) {
            setBody({ ...obj, 'id': data[0].id })
        } else {
            setBody(obj)
        }
    }

    return (
        <Stack width='100%' justifyContent='center' flexDirection='row' component='form' onSubmit={handleSubmit} >
            <Stack spacing={5} className="form_container" alignItems='center' >
                <Typography textAlign='center' variant="h5" color="primary">{data ? 'Editar producto' : 'Añadir nuevo producto'}</Typography>

                <Stack alignItems='center' width='100%' spacing={3} >
                    <TextField
                        sx={{ width: '80%' }}
                        label="Producto"
                        type="search"
                        variant="standard"
                        name='product'
                        value={product}
                        onChange={handleInputChange}
                        required
                    />
                </Stack>
                <Stack flexDirection='row' alignItems='flex-end' justifyContent='space-between' width='80%'>
                    <Autocomplete
                        disablePortal
                        options={['m2', 'ud', 'm3', '']}
                        sx={{ width: 130 }}
                        size='small'
                        value={measure || null}
                        onChange={(event, newValue) => {
                            handleInputChange({ target: { name: 'measure', value: newValue || '' } });
                        }}
                        renderInput={(params) => <TextField {...params} variant="standard" label="Unidad" required />}
                    />
                    <TextField
                        sx={{ width: 130 }}
                        label="Precio"
                        type="number"
                        variant="standard"
                        name='price'
                        value={price}
                        onChange={handleInputChange}
                        InputProps={{ inputProps: { inputMode: "decimal" } }}
                    />
                    <Autocomplete
                        disablePortal
                        options={['Alquiler', 'Servicio', '']}
                        sx={{ width: 130 }}
                        size='small'
                        value={type || null}
                        onChange={(event, newValue) => {
                            handleInputChange({ target: { name: 'type', value: newValue || '' } });
                        }}
                        renderInput={(params) => <TextField {...params} variant="standard" label="Tipo" required />}
                    />
                </Stack>

                <Stack flexDirection='row' flexWrap='wrap' justifyContent='center' gap={5} paddingTop='1rem'>
                    <Button sx={{ width: '100px' }} variant="outlined" size='small' onClick={handleCancel}>Cancelar</Button>
                    {!data && <Button sx={{ width: '100px' }} variant="outlined" size='small' onClick={reset}>Reset</Button>}
                    <Button sx={{ width: '100px' }} variant="outlined" size='small' type='submit'>{data ? 'Editar' : 'Añadir'}</Button>
                </Stack>
            </Stack>
            {body && <Message body={body} method={data ? 'PUT' : 'POST'} reset={reset} setIsCreate={setBody} messages={data ? messagesEditProducts : messagesCreateProducts} />}
        </Stack>
    )
}
